/**
 * 是否存在缓存名
 * @param {*} key 键名
 * @returns
 */
const isKey = (key) => {
  return localStorage.hasOwnProperty(key);
};

/**
 * 浏览器存储 localStorage
 * 总大小一般5M
 */
const local = {
  /**
   * 读取缓存
   * @param {string} key 关键词
   */
  getItem: (key) => {
    if (!key) return;
    return localStorage.getItem(key);
  },
  /**
   * 写入缓存
   * @param {string} key 关键词
   * @param {object} content 内容
   */
  setItem: (key, content) => {
    if (!key) return;
    return localStorage.setItem(key, content);
  },
  /**
   * 异步移除存储关键字内容
   *  @param {string} key 关键词
   */
  removeItem: (key) => {
    if (!key) return;
    return localStorage.removeItem(key);
  },
  /**
   * 清空本地存储
   */
  clear: () => {
    return localStorage.clear();
  },
  /**
   * 取出所有值
   */
  all: () => {
    return localStorage.valueOf(); //取出所有值
  },
  /**
   * 取出所有缓存key
   */
  keys: () => {
    // name  length  key  getItem  setItem   removeItem  clear  共有7个
    let res = [];
    for (var key in localStorage) {
      // console.log(key);
      if (isKey(key)) {
        res.push(key);
      }
    }
    return res;
  },
  isKey
};

/**
 * 当前会话存储
 */
const session = {
  /**
   * 获取当前会话
   * @param {*} name 存储关键词
   */
  getItem: (name) => {
    if (!name) return;
    return sessionStorage.getItem(name);
  },
  /**
   * 写入当前会话
   *  @param {string} name 关键词
   */
  setItem: (name, content) => {
    if (!name || !content) return;
    // if (typeof content !== 'string') {
    //   content = JSON.stringify(content);
    // }
    return sessionStorage.setItem(name, content);
  },
  /**
   * 异步移除存储关键字内容
   *  @param {string} name 关键词
   */
  removeItem: (name) => {
    if (!name) return;
    return sessionStorage.removeItem(name);
  },
  /**
   * 清空当前会话
   */
  clear: () => {
    return sessionStorage.clear();
  }
};

export { local, session };
